import { render, staticRenderFns } from "./ModalSelectDiscount.vue?vue&type=template&id=65c2b816"
import script from "./ModalSelectDiscount.vue?vue&type=script&lang=js"
export * from "./ModalSelectDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports